// extracted by mini-css-extract-plugin
export default {"ChatPageContainer":"chatlayout_ChatPageContainer__dUUli","ChatPageContent":"chatlayout_ChatPageContent__juMTG"};